export default __webpack_public_path__ + "static/status.broadcom.com_services_carbon-black-c4380db8fc7672b2a3fe713ad53f770d.webp";